module.exports = __webpack_public_path__ + "img/lemarche.88920c7d.png";